import React from 'react';
import { Form } from 'react-bootstrap';
import { asciiScanField } from '@/pages/fulfillment/components/asciiScanField';
import {
  PRODUCT_BARCODE_ERROR,
  PRODUCT_BARCODE_HINT,
  isInvalidEditedProductBarcode,
  normalizeProductBarcode,
} from '@/utils/productBarcode';

interface ProductBarcodeFieldProps {
  barcode: string | undefined;
  originalBarcode: string | undefined;
  onBarcodeChange: (barcode: string) => void;
}

// The same rule the warehouse registers barcodes with, so editing a product never strips a lettered barcode.
export const ProductBarcodeField: React.FC<ProductBarcodeFieldProps> = ({
  barcode,
  originalBarcode,
  onBarcodeChange,
}) => {
  const invalid = isInvalidEditedProductBarcode(barcode, originalBarcode);
  const errorId = React.useId();

  return (
    <div className="col-md-12">
      <Form.Label style={{ fontSize: '0.75rem', fontWeight: '600' }}>
        Barcode
        {!barcode && (
          <span className="text-warning ms-2" style={{ fontSize: '0.7rem' }}>
            ⚠️ Missing
          </span>
        )}
      </Form.Label>
      <Form.Control
        size="sm"
        type="text"
        aria-label="Barcode"
        aria-invalid={invalid || undefined}
        aria-describedby={invalid ? errorId : undefined}
        value={barcode || ''}
        {...asciiScanField((value) => onBarcodeChange(normalizeProductBarcode(value)))}
        placeholder={`${PRODUCT_BARCODE_HINT} (UPC, EAN, JAN, ISBN, …)`}
        isInvalid={invalid}
      />
      {invalid && (
        <Form.Control.Feedback id={errorId} type="invalid">
          {PRODUCT_BARCODE_ERROR}
        </Form.Control.Feedback>
      )}
    </div>
  );
};
